import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MyspotCardModule, MyspotDialogsModule } from '@myspot_org/ngx-ui/components';
import { MyspotDirectiveModule } from '@myspot_org/ngx-ui/directives';
import { TranslateCompiler, TranslateModule } from '@ngx-translate/core';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { LayoutModule } from '@angular/cdk/layout';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth, OktaAuthOptions } from '@okta/okta-auth-js';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TokenInterceptor } from './util/token.interceptor';
import { CookieService } from 'ngx-cookie-service';
import {
    LodgingBusinessAPIService,
    MeetingRoomAPIService,
    PrivacyService,
    WHITE_LABEL_CONFIG,
    WhiteLabelService,
} from '@myspot_org/ngx-services';
import { HomeComponent } from './home/home.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { whiteLabelConfig } from './white-label-config';
import config from './app-config';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { fuseConfig } from './fuse-config';
import { FuseModule } from '@fuse/fuse.module';

const authConfig: OktaAuthOptions = {
    clientId: config.oidc.clientId,
    issuer: config.oidc.issuer,
    redirectUri: config.oidc.redirectUri,
    postLogoutRedirectUri: typeof window !== 'undefined' ? window.location.origin : '',
    scopes: config.oidc.scopes,
    pkce: config.oidc.pkce,
    tokenManager: {
        autoRenew: true,
        autoRemove: true,
        expireEarlySeconds: 30,
        storage: 'localStorage',
    },
    services: {
        autoRenew: true
    }
};
const oktaAuth = new OktaAuth(authConfig);
@NgModule({
    declarations: [AppComponent, HomeComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        CommonModule,
        BrowserAnimationsModule,
        MyspotCardModule,
        MyspotDirectiveModule,
        MyspotDialogsModule,
        OktaAuthModule,
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        LayoutModule,
        FlexLayoutModule,
        TranslateModule.forRoot({
            compiler: {
                provide: TranslateCompiler,
                useClass: TranslateMessageFormatCompiler,
            },
        }),
        MatButtonModule], providers: [
            { provide: OKTA_CONFIG, useValue: { oktaAuth } },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: TokenInterceptor,
                multi: true,
            },
            CookieService,
            LodgingBusinessAPIService,
            MeetingRoomAPIService,
            PrivacyService,
            WhiteLabelService,
            {
                provide: WHITE_LABEL_CONFIG,
                useValue: whiteLabelConfig,
            },
            provideHttpClient(withInterceptorsFromDi()),
        ]
})
export class AppModule { }
